import { render, staticRenderFns } from "./UserProfileDialog.vue?vue&type=template&id=4bd62192&scoped=true"
import script from "./UserProfileDialog.vue?vue&type=script&lang=js"
export * from "./UserProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./UserProfileDialog.vue?vue&type=style&index=0&id=4bd62192&prod&scoped=true&lang=css"
import style1 from "./UserProfileDialog.vue?vue&type=style&index=1&id=4bd62192&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd62192",
  null
  
)

export default component.exports